module.exports = __webpack_public_path__ + "img/Posada-cabo_0000_hotel2.09f1a7ec.jpg";